export default function VelocidadePlanos(props) {
    return( 
        <span>{props.velocidade}</span>
    );
}